/**
 * 魂格ごとの特殊攻撃エフェクト設定
 *
 * 各モンスターの属性に応じた視覚エフェクトを定義する。
 * - particleColor: ヒットパーティクルの色
 * - trailType: オーブの軌跡タイプ
 * - orbShape: オーブの形状
 */

export type TrailType = 'flame' | 'wisp' | 'wind' | 'rock' | 'water' | 'leaf' | 'claw' | 'neutral' | 'doll' | 'cursed_fluff';

export interface MonsterEffectConfig {
  /** パーティクルの色 */
  particleColor: number;
  /** パーティクルの補助色 */
  particleSubColor: number;
  /** 軌跡タイプ */
  trailType: TrailType;
  /** オーブ画像キー（Phaserアセットキー） */
  orbImageKey: string;
}

export const MONSTER_EFFECT_CONFIG: Record<string, MonsterEffectConfig> = {
  zaag: {
    particleColor: 0xc0c0c0,
    particleSubColor: 0xffffff,
    trailType: 'neutral',
    orbImageKey: 'orb_neutral',
  },
  gardan: {
    particleColor: 0x8b6914,
    particleSubColor: 0xaa8844,
    trailType: 'rock',
    orbImageKey: 'orb_rock',
  },
  roona: {
    particleColor: 0x87ceeb,
    particleSubColor: 0xbbddff,
    trailType: 'wisp',
    orbImageKey: 'orb_wisp',
  },
  zephyr: {
    particleColor: 0x2e8b57,
    particleSubColor: 0x66cc88,
    trailType: 'wind',
    orbImageKey: 'orb_wind',
  },
  balga: {
    particleColor: 0x191970,
    particleSubColor: 0x4444aa,
    trailType: 'water',
    orbImageKey: 'orb_water',
  },
  morsu: {
    particleColor: 0x006400,
    particleSubColor: 0x44aa44,
    trailType: 'leaf',
    orbImageKey: 'orb_leaf',
  },
  graon: {
    particleColor: 0x800080,
    particleSubColor: 0xcc44cc,
    trailType: 'claw',
    orbImageKey: 'orb_claw',
  },
  igna: {
    particleColor: 0xff4500,
    particleSubColor: 0xffaa00,
    trailType: 'flame',
    orbImageKey: 'orb_flame',
  },
  erebos: {
    particleColor: 0x9932cc,
    particleSubColor: 0xcc88ff,
    trailType: 'neutral',
    orbImageKey: 'orb_erebos',
  },
  erebos_form2: {
    particleColor: 0x1a1a2e,
    particleSubColor: 0x6644aa,
    trailType: 'neutral',
    orbImageKey: 'orb_erebos_form2',
  },
  alice: {
    particleColor: 0x6600cc,
    particleSubColor: 0x220044,
    trailType: 'doll',
    orbImageKey: 'orb_doll',
  },
  mococo: {
    particleColor: 0xff99cc,
    particleSubColor: 0x330022,
    trailType: 'cursed_fluff',
    orbImageKey: 'orb_cursed_fluff',
  },
};

/** デフォルトエフェクト設定（未知のモンスター用） */
export const DEFAULT_MONSTER_EFFECT: MonsterEffectConfig = {
  particleColor: 0xffffff,
  particleSubColor: 0xcccccc,
  trailType: 'neutral',
  orbImageKey: 'orb_neutral',
};

/**
 * モンスターIDからエフェクト設定を取得
 */
export function getMonsterEffect(monsterId: string | undefined): MonsterEffectConfig {
  if (!monsterId) return DEFAULT_MONSTER_EFFECT;
  return MONSTER_EFFECT_CONFIG[monsterId] ?? DEFAULT_MONSTER_EFFECT;
}
